// extracted by mini-css-extract-plugin
module.exports = {"container":"CardTitle_container_yEPCf","title":"CardTitle_title_2G6QM"};